<template lang="pug">
v-container(
  class="promotion-history-container"
) 
  template(v-if="!promo_history_list.length")
    .promotion-history-card
      h3.header-title Redeemed Coupons
      b You currently have no redeemed coupons.
  template(v-else)
    .promotion-history-card
      h3.header-title Redeemed Coupons
      v-list(
        three-line
      )
        template(
          v-for="(p, index) in promo_history_list"
        )
          v-card(
            color="white"
            class="mx-2"
            :key="index"
          ) 
            v-card-text
              v-list-item-avatar(
                color="grey darken-3"
              )
                v-img(
                  :src="p.promo_imageurl"
                )
              b.mx-4 Promo Code: {{ p.promo_code }} 
            v-chip(
              small
              outlined
              class="ml-2 mb-2 red"
              label text-color="red darken-4"
            ) Redeemed on {{ parseDate(p.promo_usedt) }}
</template>

<script>
// promo_code, promo_imageurl
import config from "@/config";
import errorTags from "@/errorTags";

import parseDate from "@/mixins/parseDate";

export default {
  mixins: [parseDate],
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      promo_history_list: []
    }
  },
  mounted() {
    this.getPromotionHistoryList();
    console.log(this.promo_history_list);
  },
  methods: {
    getPromotionHistoryList() {
    let url = config.promotionHistoryUrl();

    var json = {
      params: {
      customer_id: this.$store.getters.customerId,
      customer_sessiontoken: this.$store.getters.sessionToken
      }
    };

    this.loading = true;

    this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.promo_history_list = response.body.data;
                console.log(this.promo_history_list);
              } else {
                this.$swal(
                  this.$t("error.get_promotion_history"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_promotion_history"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_promotion_history"),
            response.body.message,
            "error"
          );
        });
    },
  }
}
</script>